<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-container">
        <!-- Logo -->
        <div class="navbar-logo">
          <router-link to="/">
            <img class="Logo" :src="Logo" alt="Logo" />
          </router-link>
        </div>

        <!-- Full Version Navbar Links (Desktop) -->
        <ul class="navbar-links">
          <li><a href="/YunusRajabiy">{{ $t("Features") }}</a></li>
          <li><a href="/Aloqa">{{ $t("Contact") }}</a></li>
          <li><a href="/Vertual">{{$t("Vertual")}}</a></li>
          <li>
            <div class="select">
              <select v-model="selectedLanguage" @change="changeLanguage">
                <option value="uz">O'zbek</option>
                <option value="en">English</option>
                <option value="ru">Русский</option>
              </select>
            </div>
          </li>
        </ul>

        <!-- Sidebar for Responsive Version -->
        <div class="sidebar" :class="{ 'is-active': isMenuOpen }">
          <!-- Close Icon -->
          <div class="close-icon" @click="toggleMenu">×</div>
          <ul class="sidebar-links">
            <li><a href="/YunusRajabiy">{{ $t("Features") }}</a></li>
            <li><a href="/Aloqa">{{ $t("Contact") }}</a></li>
            <li><a href="/Vertual">{{$t("Vertual")}}</a></li>
            <li>
              <div class="select">
                <select v-model="selectedLanguage" @change="changeLanguage">
                  <option value="uz">O'zbek</option>
                  <option value="en">English</option>
                  <option value="ru">Русский</option>
                </select>
              </div>
            </li>
          </ul>
        </div>

        <!-- Navbar Toggle Button (Hamburger) -->
        <div class="btn navbar-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup>
import Logo from "@/assets/images/bg.png";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

const store = useStore();
const { t, locale } = useI18n();

const selectedLanguage = computed({
  get() {
    return store.getters.getSelectedLanguage;
  },
  set(newLang) {
    store.dispatch("changeLanguage", newLang);
    locale.value = newLang;
    window.location.reload();
  },
});

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<style scoped>
/* Navbar Styles */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1E1E19;
  color: #EBE9CF;
  padding: 15px 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
 
}

.Logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

/* Full Version Navbar Links */
.navbar-links {
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 25px;
  list-style: none;
  color: #EBE9CF;
  margin: 0;
}

.navbar-links li a {
  text-decoration: none;
  color: #EBE9CF;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.navbar-links li a:hover {
  background-color: #444;
  color: #EBE9CF;
  border-radius: 5px;
}

.navbar-links li a::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 3px;
  background-color: #fff;
  transition: width 0.3s ease;
}

.navbar-links li a:hover::before {
  width: 100%;
}

/* Select Styling */
.select {
  position: relative;
  display: inline-block;
}

.select select {
  padding: 8px 15px;
  font-size: 16px;
  background-color: #2c2c2c;
  color: #EBE9CF;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.select select:hover {
  background-color: #444;
}

/* Sidebar Styles (Mobile) */
.sidebar {
  position: fixed;
  top: 0;
  right: -100%; /* Hidden by default */
  width: 250px;
  height: 100%;
  background-color: #333;
  color: #EBE9CF;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: right 0.3s ease-in-out;
  z-index: 1100;
}

.sidebar.is-active {
  right: 0; /* Slides in when active */
}

.close-icon {
  font-size: 24px;
  color: #EBE9CF;
  cursor: pointer;
  margin-bottom: 20px;
  text-align: right;
}

.sidebar-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sidebar-links li a {
  text-decoration: none;
  color: #EBE9CF;
  font-size: 16px;
  padding: 10px 15px;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.sidebar-links li a:hover {
  background-color: #444;
}

/* Navbar Toggle Button (Hamburger) */
.navbar-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
}

.navbar-toggle span {
  background-color: white;
  height: 3px;
  width: 30px;
  border-radius: 2px;
}

/* Responsive Styles */
@media (max-width: 768px) {
  /* Hide regular navbar links in mobile */
  .navbar-links {
    display: none;
  }

  /* Show the sidebar toggle button */
  .navbar-toggle {
    display: flex;
  }

  .Logo {
    width: 60px;
    height: 60px;
  }

  .select select {
    font-size: 14px;
    padding: 6px 12px;
  }
}

@media (max-width: 480px) {
  .navbar {
    padding: 10px 15px;
  }

  .Logo {
    width: 50px;
    height: 50px;
  }

  .select select {
    font-size: 12px;
    padding: 5px 10px;
  }
}
</style>
